@if (show) {
  <app-popup
    heading="Invite Organizations to Join"
    [showFooterButtons]="false"
    [showCloseIcon]="true"
    (cancelClicked)="close()"
  >
    <div class="invite-popup-content">
      <div class="icon-container">
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4ZM12 18C10.9 18 10 18.9 10 20C10 21.1 10.9 22 12 22C13.1 22 14 21.1 14 20C14 18.9 13.1 18 12 18ZM18 9C16.9 9 16 9.9 16 11C16 12.1 16.9 13 18 13C19.1 13 20 12.1 20 11C20 9.9 19.1 9 18 9ZM6 9C4.9 9 4 9.9 4 11C4 12.1 4.9 13 6 13C7.1 13 8 12.1 8 11C8 9.9 7.1 9 6 9Z"
            fill="#334EA5"
            opacity="0.2"
          />
          <path
            d="M19 13H18.5C17.5 13 16.7 13.6 16.3 14.4C17.3 15.2 18 16.5 18 18V19H22V17.5C22 15 19.5 13 19 13ZM6 13C5.5 13 3 15 3 17.5V19H10V18C10 16.5 10.7 15.2 11.7 14.4C11.3 13.6 10.5 13 9.5 13H6ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9ZM12 16C9.79 16 8 17.79 8 20V22H16V20C16 17.79 14.21 16 12 16Z"
            fill="#334EA5"
          />
        </svg>
      </div>
      <h3>Share Registration Link</h3>
      <p class="instruction-text">
        To invite an organization to join the ACC Data Hub Portal, share the
        registration link below with their administrator.
      </p>
      <div class="steps-container">
        <div class="step">
          <div class="step-number">1</div>
          <div class="step-content">
            <h4>Copy the Link</h4>
            <p>Click the copy button to copy the registration form link</p>
          </div>
        </div>
        <div class="step">
          <div class="step-number">2</div>
          <div class="step-content">
            <h4>Share with Organization Admin</h4>
            <p>
              Send the link to the administrator of the organization you want to
              invite
            </p>
          </div>
        </div>
        <div class="step">
          <div class="step-number">3</div>
          <div class="step-content">
            <h4>Application Review</h4>
            <p>
              Once they submit the form, the ACC Data Hub Portal admin will
              review their application
            </p>
          </div>
        </div>
      </div>
      <div class="link-container">
        <div class="link-box">
          <input
            type="text"
            [value]="registrationLink"
            readonly
            #linkInput
            class="link-input"
          />
          <button
            class="copy-btn"
            (click)="copyLink(linkInput.value)"
            [class.copied]="linkCopied"
          >
            @if (!linkCopied) {
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
                  fill="currentColor"
                />
              </svg>
              <span>Copy Link</span>
            } @else {
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
                  fill="currentColor"
                />
              </svg>
              <span>Copied!</span>
            }
          </button>
        </div>
      </div>
    </div>
  </app-popup>
}
